import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WhatsAppButton from "./components/ui/WhatsAppButton"
import Header from "./components/layout/Header";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Footer from "./components/layout/Footer";

function App() {
  return (
    <Router>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
<WhatsAppButton />
      <Footer />
    </Router>
  );
}

export default App;
